import React from 'react';
import StatusCard from './StatusCard';

const DashboardCounts = ({ dashboardData = {}, onPhysicalsClick, onDrugScreenClick, onVaccinesClick, onMissingClaimNumbersClick }) => {
  return (
    <div className="row">
      {/* Physicals Card */}
      <div className="col-md-3 col-12 mb-2 pb-1">
        <StatusCard
          title="Physicals"
          className="blue-orichid"
          donutChart={{
            segments: [
              { color: '#0DAC59', dashArray: '245.04422698000383 163.36281798666926', dashOffset: 0 },
              { color: '#F6447E', dashArray: '122.52211349000191 285.88493147667117', dashOffset: -245.04422698000383 },
              { color: '#7D4BC5', dashArray: '40.840704496667314 367.5663404700058', dashOffset: -367.56634047000574 }
            ],
            icon: (
              <>
                <circle cx="15.9987" cy="7.74992" r="4.41667" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21.3346 28V16.5898" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15.9989 22.6667H12.6655C11.561 22.6667 10.6655 23.5621 10.6655 24.6667V26.6667C10.6655 27.4031 11.2625 28 11.9989 28H23.9989C25.4717 28 26.6656 26.8061 26.6656 25.3334V23.1292C26.6729 20.055 24.5747 17.3756 21.5885 16.6456C17.9118 15.7848 14.0859 15.7848 10.4092 16.6456C7.42298 17.3755 5.32471 20.0551 5.33205 23.1292L5.3322 26.6667" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15.9987 16V28" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
              </>
            )
          }}
          stats={[
            { label: 'Completed', value: dashboardData?.physicals?.completed ?? 0, color: '#0DAC59' },
            { label: 'Pending', value: dashboardData?.physicals?.pending ?? 0, color: '#E4B200' },
            { label: 'Failed', value: dashboardData?.physicals?.failed ?? 0, color: '#F6447E' }
          ]}
          onSettingsClick={onPhysicalsClick}
        />
      </div>

      {/* Drug Screen Card */}
      <div className="col-md-3 col-12 mb-2 pb-1">
        <StatusCard
          title="Drug Screen"
          className="pale-purple"
          donutChart={{
            segments: [
              { color: '#0DAC59', dashArray: '245.04422698000383 163.36281798666926', dashOffset: 0 },
              { color: '#F6447E', dashArray: '122.52211349000191 285.88493147667117', dashOffset: -245.04422698000383 },
              { color: '#E4B200', dashArray: '40.840704496667314 367.5663404700058', dashOffset: -367.56634047000574 }
            ],
            icon: (
              <>
                <circle cx="11.3308" cy="11.3313" r="3.33472" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M23.1448 18.3342L18.3334 23.1455C17.189 24.29 15.3349 24.29 14.1904 23.1455V23.1455C13.0459 22.001 13.0459 20.1469 14.1904 19.0025L19.0017 14.1911C20.1462 13.0466 22.0003 13.0466 23.1448 14.1911V14.1911C24.2906 15.3356 24.2906 17.1897 23.1448 18.3342Z" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.6094 16.6108L20.7244 20.7272" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M22.6666 28.0049H9.32774C6.38118 28.0049 3.99219 25.6159 3.99219 22.6693V9.33043C3.99219 6.38387 6.38118 3.99487 9.32774 3.99487H22.6666C25.6132 3.99487 28.0022 6.38387 28.0022 9.33043V22.6693C28.0022 25.6159 25.6132 28.0049 22.6666 28.0049Z" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
              </>
            )
          }}
          stats={[
            { label: 'Negative', value: dashboardData?.drug_screen?.negative ?? 0, color: '#0DAC59' },
            { label: 'Positive', value: dashboardData?.drug_screen?.positive ?? 0, color: '#7D4BC5' },
            { label: 'Pending', value: dashboardData?.drug_screen?.pending ?? 0, color: '#F6447E' }
          ]}
          onSettingsClick={onDrugScreenClick}
        />
      </div>

      {/* Vaccines Card */}
      <div className="col-md-3 col-12 mb-2 pb-1">
        <StatusCard
          title="Vaccines"
          className="linear_gradient"
          donutChart={{
            segments: [
              { color: '#0DAC59', dashArray: '245.04422698000383 163.36281798666926', dashOffset: 0 },
              { color: '#E4B200', dashArray: '122.52211349000191 285.88493147667117', dashOffset: -245.04422698000383 },
              { color: '#F6447E', dashArray: '40.840704496667314 367.5663404700058', dashOffset: -367.56634047000574 }
            ],
            icon: (
              <>
                <path d="M17.7734 10.9866L23.3201 5.43994" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M26.6818 8.80005L21.1484 14.3467" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.6016 7.81323L24.3349 17.5332" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.86667 23.2666L4 28.1333" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9.83984 16.4668L11.7865 18.4135" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.7617 13.5466L14.7084 15.4933" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21.9336 4.05347L28.0003 10.1201" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22.4611 15.6641L13.7451 24.3801C12.7038 25.4214 11.0158 25.4214 9.97445 24.3801L7.83178 22.2401C6.79045 21.1988 6.79045 19.5108 7.83178 18.4694L16.5478 9.75342" stroke="#5F6C85" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
              </>
            )
          }}
          stats={[
            { label: 'Completed', value: dashboardData?.vaccines?.completed ?? 0, color: '#0DAC59' },
            { label: 'Pending', value: dashboardData?.vaccines?.pending ?? 0, color: '#E4B200' },
            { label: 'Failed', value: dashboardData?.vaccines?.failed ?? 0, color: '#F6447E' }
          ]}
          onSettingsClick={onVaccinesClick}
        />
      </div>

      {/* Missing Claim Numbers Card */}
      <div className="col-md-3 col-12 mb-2 pb-1">
        <StatusCard
          title="Missing Claim Numbers"
          className="olivegreen"
          donutChart={{
            segments: [
              { color: '#0DAC59', dashArray: '245.04422698000383 163.36281798666926', dashOffset: 0 },
              { color: '#E4B200', dashArray: '122.52211349000191 285.88493147667117', dashOffset: -245.04422698000383 },
              { color: '#F6447E', dashArray: '40.840704496667314 367.5663404700058', dashOffset: -367.56634047000574 }
            ],
            centerContent: {
              title: 'Total',
              value: dashboardData?.missing_claim_numbers?.total ?? 0
            }
          }}
          stats={[
            { label: 'Total', value: dashboardData?.missing_claim_numbers?.total ?? 0, color: '#7D4BC5' },
            { label: 'Completed', value: dashboardData?.missing_claim_numbers?.completed ?? 0, color: '#0DAC59' },
            { label: 'Pending', value: dashboardData?.missing_claim_numbers?.pending ?? 0, color: '#E4B200' },
            { label: 'Failed', value: dashboardData?.missing_claim_numbers?.failed ?? 0, color: '#F6447E' }
          ]}
          onSettingsClick={onMissingClaimNumbersClick}
        />
      </div>
    </div>
  );
};

export default DashboardCounts;